<template>
    <v-modal-slot id="change-expedient-media-category-modal"
                  @accepted="acceptModal">
        <template v-slot:modal-title>
            {{ name }}
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Categoría: </label>
                        <select class="form-control" aria-label="Categoría" v-model="selected_category">
                            <option :value="category.key" v-for="category in availableMediaCategories">{{ category.value }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>

import VModal from "../../../general/VModal";
import {getMediaCategories, setMediaCollection} from "../../../../helpers/requests/RequestsMedia";
import VModalSlot from "../../../general/VModalSlot";

export default {
    name: "ExpedientDetailChangeMediaCategory",
    components: {VModalSlot, VModal},
    data() {
        return {
            availableMediaCategories: [],
            selected_category: '',
        }
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        fileId: {
            type: Number,
            required: true,
        },
        expedientId: {
            type: Number,
            required: true,
        },
        category: {
            type: String,
            required: false,
        },

    },
    async mounted() {
        await this.loadMediaCategories();
        this.selected_category = this.category;
    },
    methods: {
        async loadMediaCategories() {
            this.availableMediaCategories = await getMediaCategories();
        },
        async acceptModal() {
            if (this.selected_category !== null && this.selected_category !== "") {
                await setMediaCollection(this.expedientId, this.fileId, this.selected_category);
                this.$store.dispatch('app/setToastMessage', 'Categoría del fichero cambiada con éxito');

                this.$emit('category-changed');
            }
        },
    },
}
</script>
